import {
  InvalidSessionErrorsCodes,
  errorType,
  ErrorType,
} from "../types/error.definition";
import { Error } from "../types/error.definition";

export const isValidErrorFormat = (error: Error) =>
  !!error.code && !!error.message;

export const errorCategoryMapper = (error: Error) => {
  const tmpError: Error = { ...error };
  let category: ErrorType = errorType.RETRIABLE_UNEXPECTED_ERROR;

  if (InvalidSessionErrorsCodes.includes(error.code)) {
    category = errorType.NO_RETRIABLE_UNEXPECTED_ERROR;
  } else {
    category = errorType.RETRIABLE_UNEXPECTED_ERROR;
  }
  return { ...tmpError, category };
};
